/**
 * Validate for valid COC (currently only check dutch format)
 */
export const isValidCOC = (value?: string): string | void => (value && !/^[0-9]{8}$/.test(value) ? 'global.not_a_valid_coc' : undefined)
